const parseJSON = (data: string | null | undefined) => {
  try {
    if (data === null || data === undefined) {
      return data
    }
    return JSON.parse(data)
  } catch (error) {
    return undefined
  }
}

export default parseJSON
